import React from "react";
import upperFirst from "lodash/upperFirst";

import { Modal, Row, Col } from "antd";

import CustomButton from "../../../../components/CustomButton";
import { WrapperModalComponent } from "./styled";
import { componentList } from "../../manage-content.utils";
import { ModalComponentType } from "../../manage-content.types";

const ModalComponent = ({ visible, onChange, push, onCancel }: ModalComponentType): JSX.Element => (
    <Modal
        visible={visible}
        footer={false}
        width={1000}
        bodyStyle={{ paddingTop: 40 }}
        onCancel={onCancel}
    >
        <Row gutter={24}>
            {componentList.map((res, index) => (
                <Col span={6} key={index}>
                    <CustomButton
                        type={"text"}
                        onClick={() =>
                            onChange(
                                {
                                    type: res.type,
                                    fields: res.fields,
                                },
                                push
                            )
                        }
                    >
                        <WrapperModalComponent>
                            <img src={res.image} alt="" />
                        </WrapperModalComponent>
                        {upperFirst(res.type)}
                    </CustomButton>
                </Col>
            ))}
        </Row>
    </Modal>
);
export default ModalComponent;
